import React from "react";
import { useSelector } from "react-redux";
import { selectUserFields } from "../../Store/slices/user.slice";
import { Alert, Card, Col, Layout, Row, Typography, Divider, Empty } from "antd"; // Import Typography from antd for styled text
import HomeHeader from "../HomeHeader";
const { Content } = Layout;


const IQPlatformHome = () => {
      const files = [
    {
        fileName: "Intelligent Allocation Whitepaper",
        date: "March 23, 2024",
        fileType: "pdf",
        uri: 'https://storage.googleapis.com/resources.iaplatform.app/whitepapers/Intelligent%20Allocation%20(Styled).pdf'
    },
    { fileName: "iindex Whitepaper", date: "April 13, 2024", fileType: "doc" },
  ];
    const settings = useSelector((state) => selectUserFields(state, 'settings'));
    const { items } = useSelector((state) => state.portfolios);
    const portfoliosWithFormattedDate = items.map((portfolio) => ({
        ...portfolio,
        inceptionDate: new Date(portfolio.inception_date * 1000).toLocaleDateString(),
    }));

    return (
        <Layout style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundSize: '100% 100%',
        }}>
            <div style={{background: '#FFFFFF', height: '100%'}}>
                <HomeHeader username={`${settings?.display_name?? ''} to the IQ Platform`}
                            backgroundImage='transparent'
                />
                <Content style={{
                    padding: '2.5%',
                    height: 'auto',
                }}>
                    <Row gutter={[16, 16]} justify={'space-between'}>
                        <Col xs={16} lg={12}>

                        </Col>
                        <Col xs={24} lg={8} xxl={6} offset={1} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        </Col>
                    </Row>
                </Content>
            </div>
        </Layout>
    );
};

export default IQPlatformHome;
